export default "__VITE_ASSET__92n$YmPt__"